import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { withRouter } from 'react-router-dom';

const token = localStorage.getItem('authToken');

class EditCaste extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caste: "",
      subcaste: "",
      gotra: "",
      submissionStatus: null,
      submeet: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const { id } = match.params;
    this.setState({ id });
    this.fetchData(id);
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/caste/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the headers
        }
      });
    //   console.log(response.data.caste,"d")
      if (response && response.data && response.data) {
        const { caste, subcaste, gotra } = response.data;
     
        this.setState({
          caste: caste || "",
          subcaste: subcaste || "",
          gotra: gotra || "",
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.state;
    this.setState({ submeet: true });

    const { caste, subcaste, gotra } = this.state;

    try {
      const formData = new FormData();
      formData.append("caste", caste);
      formData.append("subcaste", subcaste);
      formData.append("gotra", gotra);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/caste/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push("/casteList"); // Redirect using history
        }, 2000);
      }

      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { submeet, caste, subcaste, gotra, submissionStatus } = this.state;

    const isValid = (value) => value && value.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Caste</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Caste</label>
                <input
                  className={`form-control ${!isValid(caste) && submeet && "parsley-error"}`}
                  value={caste}
                  name="caste"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ caste: e.target.value });
                  }}
                />
                {submeet && !isValid(caste) && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Sub Caste (Optional)</label>
                <input
                  className={`form-control`}
                  value={subcaste}
                  name="subcaste"
                 
                  type="text"
                  onChange={(e) => {
                    this.setState({ subcaste: e.target.value });
                  }}
                />
               
              </div>

              <div className="form-group">
                <label>Gotra(Optional)</label>
                <input
                  className={`form-control`}
                  value={gotra}
                  name="gotra"
                 
                  type="text"
                  onChange={(e) => {
                    this.setState({ gotra: e.target.value });
                  }}
                />
              
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, {})(EditCaste));
